module.exports = __webpack_public_path__ + "img/应用场景_视频场景首图.cc8eac0c.png";